import { useRef, useCallback } from 'react';
import _get from 'lodash/get';

const useSimpleBarRef = () => {
    const simpleBarRef = useRef();

    const contentWrapperEl = _get(simpleBarRef, 'current.contentWrapperEl');
    const contentEl = _get(simpleBarRef, 'current.contentEl');

    const scrollToTop = useCallback(() => {
        if (contentWrapperEl) contentWrapperEl.scrollTop = 0;
    }, [contentWrapperEl]);

    return { simpleBarRef, contentWrapperEl, contentEl, scrollToTop };
};

export default useSimpleBarRef;
